const modesPerOrg = {
  1: ['tv', 'cable', 'digital_dsp_display', 'digital_dsp_video', 'youtube', 'digital_inapp', 'fb', 'snapchat', 'mail', 'phone', 'radio', 'print'],
  10: ['tv', 'spanish_tv', 'cable', 'digital', 'mobile', 'fb', 'mail', 'phone', 'radio'],
  15: ['tv', 'cable', 'digital', 'mobile', 'fb', 'mail', 'radio'],
  16: ['tv', 'hfa_tv', 'cable', 'digital', 'mobile', 'hfa_digital', 'fb', 'mail',
    'hfa_mail', 'phone', 'hfa_field', 'radio'],
  20: ['tv', 'cable', 'digital', 'mobile', 'fb', 'mail', 'radio'],
  30: ['tv', 'cable', 'digital_dsp_display', 'digital_dsp_video', 'digital_inapp', 'fb', 'snapchat', 'mail', 'phone', 'radio', 'print', 'youtube'],
  32: ['tv', 'cable', 'digital', 'mobile', 'fb', 'mail', 'radio'],
};

export default modesPerOrg;
